import axios from 'axios'
import CsvResponse from '@/domain/CsvResponse'

/**
 * CSV応答ファイルサービス
 */
export default class CsvResponsesService {
    /** インスタンス */
    private static _instance: CsvResponsesService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new CsvResponsesService();
        }
        return this._instance;
    }

    /**
     * アップロード
     */
    public async upload(list: CsvResponse[]): Promise<CsvResponse[]> {
        return await axios.post("/api/csv_responses/upload", list)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * アップデート（納期更新）
     */
    public async update(list: CsvResponse[]): Promise<CsvResponse[]> {
        return await axios.post("/api/csv_responses/update", list)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * ダウンロード
     */
    public async download(reportNos: string[]): Promise<CsvResponse[]> {
        const params = reportNos.map(x => `reportNos=${x}`).join("&")
        return await axios.get(`/api/csv_responses/download?${params}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): CsvResponse[] {
        const request = data as CsvResponse[]
        return request.map(x => new CsvResponse({ ...x }))
    }
}
